import React from 'react';
import ReactDom from 'react-dom';
import Vouchers from '../components/Vouchers.jsx';

export default {
    init() {
        ReactDom.render(<Vouchers/>, document.getElementById('vouchers'));
    },
    finalize() {

    },
};



// WEBPACK FOOTER //
// ./scripts/routes/gift-vouchers.jsx